<template>
    <CCol
        :class="classes"
    >
        <slot />
    </CCol>
</template>

<script setup>
import { CCol } from '@coreui/vue-pro'
import { computed } from 'vue'

const props = defineProps({
    col: {
        type: [String, Number],
        default: null
    },
    xs: {
        type: String,
        default: null
    },
    sm: {
        type: String,
        default: null
    },
    md: {
        type: String,
        default: null
    },
    lg: {
        type: String,
        default: null
    },
    xl: {
        type: String,
        default: null
    },
    size: {
        type: String,
        default: null
    }
})

const classes = computed(function () {
    let classes = ''

    if (props.col) {
        classes += `col-${props.col}`
    }

    if (props.xs) {
        classes += ` col-xs-${props.xs}`
    }

    if (props.sm) {
        classes += ` col-sm-${props.sm}`
    }

    if (props.md) {
        classes += ` col-md-${props.md}`
    }

    if (props.lg) {
        classes += ` col-lg-${props.lg}`
    }

    if (props.xl) {
        classes += ` col-xl-${props.xl}`
    }

    if (props.size) {
        classes += ` col-${props.size}`
    }

    return classes
})
</script>
